import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";

@Injectable()
export class ModalService {

  public modalRef: NgbModalRef;

  constructor(private modalService: NgbModal) { }

  public open(modalComponent, options): void {
    this.modalRef = this.modalService.open(modalComponent, options);
  }

  public close(): void {
    this.modalRef.close();
  }

}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/locations/modal.service.ts